/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {adminGetPoolContributionHistory} from '../api'

export const useMutationAdminGetPoolContributionHistory = createReactQueryMutationHook('adminGetPoolContributionHistory', adminGetPoolContributionHistory)
